<ng-container header>
    <div class="header-container">
        <div class="search-wrapper">
            <ham-filter
                [placeholder]="'aumico_closing_workflow_overview_search_configurations' | i18next"
                [hasFilterButton]="false"
                (filter)="onSearchFilterChange($event)"
            ></ham-filter>
        </div>
        <ham-button
            size="sm"
            variant="primary"
            icon="assets/hamIcons/plus-outline.svg"
            (click)="openCreateNewWorkflowDialog = true"
        >
            {{'aumico_closing_workflow_overview_add_new_workflow' | i18next}}
        </ham-button>
    </div>
</ng-container>

<ng-container content>
    <div class="content-container">
        <closing-workflows-table
            [workflows]="workflows"
            (editWorkflow)="editWorkflow($event)"
            (deleteWorkflow)="deleteWorkflow($event)"
        ></closing-workflows-table>
    </div>
</ng-container>

<ham-modal
    *ngIf="openCreateNewWorkflowDialog"
    title="{{ 'aumico_closing_workflow_overview_add_workflow_dialog_title' | i18next }}"
    (cancel)="openCreateNewWorkflowDialog = false"
    [size]="'lg'"
>
    <div class="workflow-start-container">
        <div class="description">
            <span>{{'aumico_closing_workflow_overview_add_workflow_dialog_description' | i18next }}</span>
        </div>

        <div class="workflow-option">
            <ham-button
                size="lg"
                variant="white"
                [outline]="true"
                rightIcon="assets/hamIcons/chevron-right.svg"
                (click)="createWorkflowFromScratch()"
            >
                {{'aumico_closing_workflow_overview_start_from_scratch' | i18next}}
            </ham-button>
        </div>

        <div class="workflow-option" [class.disabled]="workflows.length === 0">
            <ham-button
                size="lg"
                variant="white"
                [outline]="true"
                rightIcon="assets/hamIcons/chevron-right.svg"
                (click)="workflows.length !== 0 && (openSelectWorkflowTemplateDialog = true)"
            >
                {{'aumico_closing_workflow_overview_start_from_existing_workflow' | i18next}}
            </ham-button>
        </div>
    </div>
</ham-modal>

<ham-modal
    *ngIf="openSelectWorkflowTemplateDialog"
    title="{{ 'aumico_closing_workflow_overview_select_workflow_template_dialog_title' | i18next }}"
    [saveText]="'aumico_closing_workflow_overview_next_button' | i18next"
    [showCancelButton]="true"
    [cancelText]="'aumico_closing_workflow_overview_back_button' | i18next"
    (cancel)="openSelectWorkflowTemplateDialog = false"
    (save)="createWorkflowFromSelectedTemplate()"
    [size]="'lg'"
>
    <table class="workflow-table">
        <thead>
            <tr>
                <th>{{ 'aumico_closing_workflow_overview_select_workflow_template_name' | i18next }}</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let wf of workflows"
                [class.selected]="wf.workflowId === selectedWorkflowTemplateId"
                [class.disabled]="wf.disabled"
                (click)="selectWorkflowTemplate(wf.workflowId, wf.disabled)"
            >
                <td>{{ wf.name }}</td>
                <td>
                    <div class="radio" [class.selected]="wf.workflowId === selectedWorkflowTemplateId"></div>
                </td>
            </tr>
        </tbody>
    </table>
</ham-modal>

<ng-template #footerTemplate> </ng-template>
